// Application version configuration
// This file centralizes version management for the entire application

// Import version from package.json
import pkg from '../package.json';

// Application version information
export const APP_VERSION = {
  // Main version from package.json
  version: pkg.version,
  
  // Build information
  buildDate: new Date().toISOString(),
  
  // Environment-specific version suffix
  get displayVersion(): string {
    // You can add environment-specific suffixes here
    const env = (import.meta as any).env.MODE;
    if (env === 'development') {
      return `${pkg.version}-dev`;
    }
    if (env === 'staging') {
      return `${pkg.version}-staging`;
    }
    return pkg.version;
  },
  
  // Full version info for debugging
  get fullInfo(): string {
    return `v${pkg.version} (${this.buildDate})`;
  }
};

// Export individual components for convenience
export const VERSION = APP_VERSION.version;
export const BUILD_DATE = APP_VERSION.buildDate;
export const DISPLAY_VERSION = APP_VERSION.displayVersion;